// extracted by css-extract-rspack-plugin
export default {"video":"Block-module__video___VZTBr","player":"Block-module__player___pj2zF"};